import React from "react";
import Logo from "./Logo";
import { useI18n } from "../i18n";
import { Link } from "react-router-dom";

const Footer = () => {
  const { t } = useI18n();
  const year = new Date().getFullYear();

  return (
    <footer className="bg-[var(--bg)] border-t border-[var(--border)]" data-testid="site-footer">
      <div className="w-full h-[360px] relative overflow-hidden border-b border-[var(--border)]">
        <iframe
          title="Demiray Insaat Merkez Ofis — Fatih, İstanbul"
          src="https://maps.google.com/maps?q=Ayvansaray%20Mah.%20Sultan%C3%A7e%C5%9Fmesi%20Sk.%20No%3A23%20Fatih%20Istanbul&t=&z=15&ie=UTF8&iwloc=&output=embed"
          width="100%"
          height="100%"
          style={{ border: 0, filter: "grayscale(0.6) invert(0.92) hue-rotate(180deg)" }}
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          data-testid="footer-map"
        />
      </div>

      <div className="max-w-[1440px] mx-auto px-6 lg:px-12 py-16 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <Logo size={44} />
          <p className="text-sm text-[var(--text-muted)] mt-6 max-w-sm leading-relaxed">
            {t.footer.tagline}
          </p>
        </div>

        <div className="md:col-span-3">
          <div className="overline mb-5">{t.footer.navigation}</div>
          <ul className="space-y-3 text-sm">
            {["home", "about", "services", "portfolio", "whyus", "contact"].map((id) => (
              <li key={id}>
                <a href={`#${id}`} className="text-[var(--text-main)] hover:text-white" data-testid={`footer-nav-${id}`}>
                  {t.nav[id]}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-4">
          <div className="overline mb-5">{t.footer.contact}</div>
          <ul className="space-y-2 text-sm text-[var(--text-main)]">
            <li>Merkez · Düzce</li>
            <li>0532 630 38 39</li>
            <li>Balkan · Saraybosna</li>
            <li className="break-all">info@demiray.net.tr</li>
          </ul>
        </div>
      </div>

      <div className="border-t border-[var(--border)]">
        <div className="max-w-[1440px] mx-auto px-6 lg:px-12 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-[var(--text-muted)]">
          <div>© {year} Demiray İnşaat. {t.footer.rights}</div>
          <Link to="/admin/login" className="hover:text-white" data-testid="footer-admin-link">
            {t.nav.adminLogin}
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
